// (function () {
// 	const initSlider = () => {
// 		const sliders = document.querySelectorAll(".product-card-js");

// 		sliders.forEach((slider, index) => {
// 			const productSlider = new Swiper(slider, {
// 				pagination: {
// 					el: ".product-pagination .swiper-pagination",
// 					clickable: true,
// 				},
// 				navigation: {
// 					nextEl: ".product-button-group .swiper-button-next",
// 					prevEl: ".product-button-group .swiper-button-prev",
// 				},
// 				allowTouchMove: true,
// 				990: {
// 					allowTouchMove: false,
// 				},
// 			});
// 		});
// 	};

// 	initSlider();

// 	document.addEventListener("shopify:section:load", function () {
// 		initSlider();
// 	});
// })();


(function () {
  function initProductCardSliders(context = document) {
    const sliders = context.querySelectorAll(".product-card-js");

    sliders.forEach((slider) => {
      if (slider.swiper) return; // ✅ avoid double init

      new Swiper(slider, {
        pagination: {
          el: slider.querySelector(".product-pagination .swiper-pagination"),
          clickable: true,
        },
        navigation: {
          nextEl: slider.querySelector(".product-button-group .swiper-button-next"),
          prevEl: slider.querySelector(".product-button-group .swiper-button-prev"),
        },
        allowTouchMove: true,
        breakpoints: {
          990: {
            allowTouchMove: false,
          },
        },
      });
    });
  }

  // Init on first load
  document.addEventListener("DOMContentLoaded", () => {
    initProductCardSliders();
  });

  // Re-init when editing in theme editor
  document.addEventListener("shopify:section:load", (e) => {
    initProductCardSliders(e.target);
  });

  // ✅ Expose for Load More
  window.initProductCardSliders = initProductCardSliders;
})();
